<page-data-manager>
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class="page-header">
        <h2>{{cadastroPropriedade.propriedade.id ? 'Editando' : 'Nova'}} Propriedade</h2>
      </div>
    </div>

    <div class="col-xs-12">
      <form id="propriedade_form" name="propriedade_form" novalidate ng-submit="cadastroPropriedade.save(propriedade_form)">
        <div class="row">
          <div class="col-xs-6">
            <div class="form-group" ng-class="{'has-error': propriedade_form.descricao.$invalid}">
              <label for="descricao">Descrição</label>
              <input autofocus class="form-control" ng-model="cadastroPropriedade.propriedade.descricao" type="text" id="descricao" name="descricao" autocomplete="off" required>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-6">
            <div class="form-group">
              <label for="uf" class="control-label">UF</label>
              <ui-select required name="uf" id="uf" ng-model="cadastroPropriedade.filters.uf" ng-change="cadastroPropriedade.changeUf()">
                <ui-select-match>{{$select.selected}}</ui-select-match>
                <ui-select-choices repeat="uf in cadastroPropriedade.ufs | filter: $select.search">
                  <span ng-bind-html="uf | highlight: $select.search"></span>
                </ui-select-choices>
              </ui-select>
            </div>
          </div>

          <div class="col-xs-6">
            <div class="form-group">
              <label for="cidade" class="control-label">Cidade</label>
              <ui-select required name="cidade" id="cidade" ng-model="cadastroPropriedade.propriedade.cidade">
                <ui-select-match>{{$select.selected.nome}}</ui-select-match>
                <ui-select-choices repeat="cidade in cadastroPropriedade.cidades | filter: $select.search">
                  <span ng-bind-html="cidade.nome | highlight: $select.search"></span>
                </ui-select-choices>
              </ui-select>
            </div>
          </div>

        </div>

        <div class="row pull-right padding-top-10">
          <div class="col-xs-12 btn-group">
            <button class="btn btn-default btn-sm btn-action" type="button" ng-click="cadastroPropriedade.goToIndex()">Cancelar</button>

            <button class="btn btn-success btn-sm btn-action" type="submit"
                    ng-disabled="propriedade_form.$invalid" ng-if="permissions.propriedades.canManage">
              Salvar <i class="fa fa-check"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</page-data-manager>
